/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckGeneralError } from './PaxCheckGeneralError';
import {
    PaxCheckGeneralErrorFromJSON,
    PaxCheckGeneralErrorFromJSONTyped,
    PaxCheckGeneralErrorToJSON,
    PaxCheckGeneralErrorToJSONTyped,
} from './PaxCheckGeneralError';
import type { PaxCheckRecognizeDocumentError } from './PaxCheckRecognizeDocumentError';
import {
    PaxCheckRecognizeDocumentErrorFromJSON,
    PaxCheckRecognizeDocumentErrorFromJSONTyped,
    PaxCheckRecognizeDocumentErrorToJSON,
    PaxCheckRecognizeDocumentErrorToJSONTyped,
} from './PaxCheckRecognizeDocumentError';

/**
 * 
 * @export
 * @interface PaxCheckRecogniseDocumentResponseError
 */
export interface PaxCheckRecogniseDocumentResponseError {
    /**
     * 
     * @type {PaxCheckGeneralError}
     * @memberof PaxCheckRecogniseDocumentResponseError
     */
    generalError?: PaxCheckGeneralError;
    /**
     * 
     * @type {PaxCheckRecognizeDocumentError}
     * @memberof PaxCheckRecogniseDocumentResponseError
     */
    operationError?: PaxCheckRecognizeDocumentError;
}

/**
 * Check if a given object implements the PaxCheckRecogniseDocumentResponseError interface.
 */
export function instanceOfPaxCheckRecogniseDocumentResponseError(value: object): value is PaxCheckRecogniseDocumentResponseError {
    return true;
}

export function PaxCheckRecogniseDocumentResponseErrorFromJSON(json: any): PaxCheckRecogniseDocumentResponseError {
    return PaxCheckRecogniseDocumentResponseErrorFromJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRecogniseDocumentResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'generalError': json['general_error'] == null ? undefined : PaxCheckGeneralErrorFromJSON(json['general_error']),
        'operationError': json['operationError'] == null ? undefined : PaxCheckRecognizeDocumentErrorFromJSON(json['operationError']),
    };
}

export function PaxCheckRecogniseDocumentResponseErrorToJSON(json: any): PaxCheckRecogniseDocumentResponseError {
    return PaxCheckRecogniseDocumentResponseErrorToJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResponseErrorToJSONTyped(value?: PaxCheckRecogniseDocumentResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'general_error': PaxCheckGeneralErrorToJSON(value['generalError']),
        'operationError': PaxCheckRecognizeDocumentErrorToJSON(value['operationError']),
    };
}

